<section class="main ml-5">
  <div class="row w-100 justify-content-md-center">
    <div class="settings-title col-12">
      <h1>Settings</h1>
    </div>

    <div class="settings w-100" [class.col-3]="selectedOption" [class.col-6]="!selectedOption">
      <div class="settings-menu" dpadZone="'settings'" [class.option-selected]="selectedOption">
        <div class="settings-button" *ngFor="let i of options; let idx = index;">
          <button dpadSelectable [class.dpad-zone-start]="i.active" *ngIf="idx == 0" #firstOption
                  [class.dpad-start]="i.start"
                  (click)="selectOption(i.tag)" (keydown.enter)="$event.preventDefault()"
                  (keyup.enter)="selectOption(i.tag)">
            {{ i.label }}
          </button>
          <button dpadSelectable [class.dpad-zone-start]="i.active" *ngIf="idx !== 0" [class.dpad-start]="i.start"
                  (click)="selectOption(i.tag)" (keydown.enter)="$event.preventDefault()"
                  (keyup.enter)="selectOption(i.tag)">
            {{ i.label }}
          </button>
        </div>
      </div>
    </div>

    <div class="col-9 settings-content" dpadZone="'settings-content'" *ngIf="selectedOption">
      <div dpadSelectable class="option-content pt-3 scroll-colour border-top-focus"
           #scrollField>
        <markdown *ngIf="selectedOption.isDocument && selectedDocument" [data]="selectedDocument.text">
        </markdown>
        <ng-container *ngIf="selectedOption.tag == 'account'">
          <h3>Please go to <span class="highlight">{{ host }}/account</span> to change your account settings.</h3>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="app-version col-12">
    <span *ngIf="version">Version: {{ version }}</span>
    <span *ngIf="(webOsVersion$ | async) && (webOsVersion$ | async) !== 'undefined'">
    - WebOS: {{ webOsVersion$ | async }}
  </span>
    <span *ngIf="(currentPlatform$ | async) && (currentPlatform$ | async) !== 'undefined'">
    - Platform: {{ currentPlatform$ | async }}
  </span>
    <span *ngIf="(chromiumVersion$ | async) && (chromiumVersion$ | async) !== 'undefined'">
    - Chromium: {{ chromiumVersion$ | async }}
  </span>
  </div>
</section>
